import { render, staticRenderFns } from "./ModalAggiornaCert.vue?vue&type=template&id=728bb3f5"
import script from "./ModalAggiornaCert.vue?vue&type=script&lang=js"
export * from "./ModalAggiornaCert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports